import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import { getAllRows } from "../reports/ReportElementHelper";

class BusinessBccNimbusItemRecordFullDetail extends Component {
  componentDidMount() { }

  render() {
    const recs = [];
    getAllRows(
      this.props.node,
      recs,
      this.props,
      _.get(this.props.node, "$.display"),
      0,
      "",
      true,
      true,
      true
    );
    const rows = [];
    rows.push(
      <Table columns={1} key={`business_ucc_rec_nim_${1}`}>
        <Table.Body>
          <Table.Row className={"page-title-black report-sub-section-header"}>
            <Table.Cell colSpan={2}>Record Details</Table.Cell>
          </Table.Row>
          {recs}
        </Table.Body>
      </Table>
    );


    return (
      <Table>
        <Table.Body><Table.Row><Table.Cell>{rows}</Table.Cell></Table.Row></Table.Body>
      </Table>
    );
  }
}

export default BusinessBccNimbusItemRecordFullDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessBccNimbusItemRecordFullDetail.js